import { useEffect } from "react";
import { useNavigate } from "react-router";
import apiClient from "../../services/apiService";
import { useAuth } from "../../context/AuthContext";

const LogOut = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();

  useEffect(() => {
    let isMounted = true;

    async function run() {
      try {
        await apiClient.post("/auth/logout");
      } catch (err) {
        // ignore — the backend may already consider the user logged out
        console.warn("Logout request failed:", err);
      }

      if (isMounted) {
        logout();  // limpiamos estado local siempre
        navigate("/");
      }
    }

    run();

    return () => {
      isMounted = false;
    };
  }, [logout, navigate]);

  return null;
};

export default LogOut;
